import { config } from './config';
import firebase from 'firebase';


firebase.initializeApp(config);

export const auth = firebase.auth();
firebase.analytics();
export const fireauth = firebase.auth;

const settings = {};
firebase.firestore().settings(settings);

export const firestore = firebase.firestore();

export const firebasestore = firebase.firestore;

export const storage = firebase.storage()

// Create a storage reference from our storage service
export const storageRef = storage.ref();

